module.exports = __webpack_public_path__ + "static/media/loading_spinner.5fe0e55f.gif";